// Registry of recruiter-facing ML model deep-dive views.
// Each entry maps a project to its self-contained MLModelView component,
// rendered when a project icon is opened from the "Impact" window.
// Developer "Projects" view is unaffected — it still uses contentData.js.
import SCMModelView from './Supply Chain Logistics with AutoML.jsx';
import PM25ModelView from './Spatiotemporal PM2.5 Prediction.jsx';
import ApplianceModelView from './Appliance Energy Usage Forecasting.jsx';

export const mlModels = [
  {
    slug: 'scm-backorder',
    title: 'SCM Backorder Prediction',
    icon: '📦',
    colors: ['#7C3AED', '#4338CA'],
    component: SCMModelView,
  },
  {
    slug: 'pm25-prediction',
    title: 'Spatiotemporal PM2.5 Prediction',
    icon: '🌫️',
    colors: ['#0EA5E9', '#0369A1'],
    component: PM25ModelView,
  },
  {
    slug: 'appliance-energy',
    title: 'Appliance Energy Forecasting',
    icon: '⚡',
    colors: ['#F59E0B', '#B45309'],
    component: ApplianceModelView,
  },
];
